import {
  WorkflowRequirement,
  WorkflowRequirementKind,
  WorkflowStepConfig,
  WorkflowStepType,
} from "../../../../types/Transaction";

export function getWorkflowStepRequirements(
  steps: WorkflowStepConfig[] | undefined,
  stepType: WorkflowStepType
): WorkflowRequirement[] {
  return (
    steps?.find((step) => step.type === stepType)?.config?.requirements ?? []
  );
}

export function getWorkflowRequirementError(
  requirements: WorkflowRequirement[]
): string | undefined {
  const ordered = [...requirements].sort((a, b) => a.order - b.order);
  if (
    ordered.some(
      (item, index) =>
        item.kind === WorkflowRequirementKind.DECLARATION &&
        (index === 0 ||
          ordered[index - 1].kind === WorkflowRequirementKind.DECLARATION)
    )
  ) {
    return "Place each declaration immediately after a field, document, or question.";
  }
  const labeledItems = requirements.filter(
    (item) => item.kind !== WorkflowRequirementKind.DECLARATION
  );
  const labels = labeledItems.map((item) => item.label?.trim().toLowerCase());
  if (
    labeledItems.some((item) => !item.label?.trim()) ||
    new Set(labels).size !== labels.length
  ) {
    return "Give every requirement a unique label.";
  }
  if (
    requirements.some(
      (item) =>
        item.kind === WorkflowRequirementKind.DOCUMENT &&
        !item.document?.acceptedTypes?.length
    )
  ) {
    return "Choose at least one accepted file type for each document.";
  }
  if (
    requirements.some(
      (item) =>
        item.kind === WorkflowRequirementKind.DECLARATION &&
        !item.declaration?.text.trim()
    )
  ) {
    return "Add text for every declaration.";
  }
  if (
    requirements.some((item) => {
      if (item.kind !== WorkflowRequirementKind.QUESTION) return false;
      const options = item.question?.options ?? [];
      const optionLabels = options.map((option) =>
        option.label.trim().toLowerCase()
      );
      return (
        options.length < 2 ||
        options.length > 5 ||
        optionLabels.some((label) => !label) ||
        new Set(optionLabels).size !== optionLabels.length
      );
    })
  ) {
    return "Give each question 2 to 5 unique answer options.";
  }
  return undefined;
}
